import { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { HELP_CONTENT } from './constants';

export function HelpButton({ topic, className = '' }) {
  const [open, setOpen] = useState(false);
  const help = HELP_CONTENT[topic];
  
  if (!help) return null;
  
  return (
    <TooltipProvider>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <button 
            className={`text-muted-foreground hover:text-foreground transition-colors ${className}`}
            onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
          >
            <HelpCircle className="w-3.5 h-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="left" className="max-w-xs p-3">
          <p className="font-medium text-sm mb-1">{help.title}</p>
          <p className="text-xs whitespace-pre-line text-muted-foreground">{help.content}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
